import { isNull, isUndefined } from "./index";

export const isNullish = (value: unknown): value is null | undefined =>
    isNull(value) || isUndefined(value);